import { useSiteContent } from '@/context/SiteContentContext';
import ImageUploadField from './ImageUploadField';

export default function AdminTeamTab() {
  const { content, updateContent } = useSiteContent();
  const t = content.team;

  return (
    <div className="space-y-5">
      <h3 className="text-lg font-bold text-gray-900 border-b border-gray-100 pb-3">Team Section</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ImageUploadField
          label="Photo 1 (Individual)"
          value={t.photo1}
          onChange={(v) => updateContent('team.photo1', v)}
        />
        <ImageUploadField
          label="Photo 2 (Group — full width)"
          value={t.photo2}
          onChange={(v) => updateContent('team.photo2', v)}
        />
      </div>

      {(['para1', 'para2', 'para3', 'para4'] as const).map((key, i) => (
        <div key={key}>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Paragraph {i + 1}</label>
          <textarea
            value={t[key]}
            rows={3}
            onChange={(e) => updateContent(`team.${key}`, e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none"
          />
        </div>
      ))}
    </div>
  );
}
